import React, { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DownloadOutlined from '@mui/icons-material/DownloadOutlined'

import { DetailButton } from './detail'
import { exportElementAsColoredPdf } from '../../utils/exportElementAsColoredPdf'

export function useAnalysisPdfExport() {
  const ref = useRef<HTMLDivElement>(null)
  const [exporting, setExporting] = useState(false)

  const exportPdf = useCallback(
    async (filename: string) => {
      const el = ref.current
      if (!el || exporting) return
      setExporting(true)
      try {
        await exportElementAsColoredPdf({ element: el, filename })
      } catch (err) {
        console.error('Analysis PDF export failed:', err)
      } finally {
        setExporting(false)
      }
    },
    [exporting]
  )

  return { ref, exporting, exportPdf }
}

type AnalysisPdfButtonProps = {
  exporting: boolean
  disabled?: boolean
  onExport: () => void
}

export function AnalysisPdfButton({
  exporting,
  disabled,
  onExport,
}: AnalysisPdfButtonProps) {
  const { t } = useTranslation()
  return (
    <DetailButton onClick={onExport} disabled={exporting || disabled}>
      <DownloadOutlined sx={{ fontSize: 16 }} />
      {exporting ? t('buttons.exportingPdf') : t('buttons.exportPdf')}
    </DetailButton>
  )
}

export default AnalysisPdfButton
